<jw-modal id='addNewSiteTimelineModal'>
    @if(isLoaded) {
        <app-accounts-new [isPopup]='true'></app-accounts-new>
    }
</jw-modal>